import { BehaviorSubject } from 'rxjs';
import { Injectable } from '@angular/core';
import { HardwareVariantOfferingDetails } from '../accessories/models/hardware-offering-model';

@Injectable({ providedIn: 'root' })
export class EquipmentEventService {
  hardwareDetails = new BehaviorSubject<HardwareVariantOfferingDetails>(undefined);
}
